import { memo } from 'react';

import { PageSegmentLoadMetric } from '@atlassian/browser-metrics/types';

import { startMetric } from './start-metric';

type Props = {
  metric: PageSegmentLoadMetric;
};

/**
 * A convenient component wrapper for start-metric for use with PageSegmentLoadMetric
 */
export const PageSegmentMetricStarter = memo(({ metric }: Props) => {
  startMetric(metric);
  return null;
});
